import { ReportHitProps } from 'components/helpers/AlgoliaSearch/Hits/_types';
import Button from 'components/helpers/Button';
import { getReportDownloadUrl } from 'lib/util/algolia';
import classnames from 'tailwindcss-classnames';

export const CTInstructionHit = ({ hit }: ReportHitProps): JSX.Element => {
  const cssCard = classnames('bg-white', 'font-medium'); // NOTE: not sure what classes we really want here, but kept as placeholder

  const centerName: string = hit.centerName;
  const city: string = hit.city;
  const country: string = hit.country;
  const fileMatch = /\.(\w+)$/i.exec(hit.fileName || '');
  const fileExtension = fileMatch ? ` (${fileMatch[0]?.slice(1)?.toLocaleUpperCase()})` : null;
  const href = getReportDownloadUrl(hit.objectID);
  const textBlack = classnames(`text-black`);
  return (
    <div className={classnames('relative', 'text-body', 'leading-1', 'pb-2')}>
      <div className={cssCard}>
        <h3 className={classnames('leading-4', 'text-blue')}>
          <Button
            linkField={{ value: { href: href, target: '_blank' } }}
            variant="link"
            suppressLinkText="true"
            className={classnames('text-body', 'underline')}
          >
            {hit.title}
          </Button>
          {fileExtension && <span className={textBlack}>{fileExtension}</span>}
        </h3>
        {centerName && <div className={textBlack}>{centerName}</div>}
        {city && <div className={textBlack}>{city}</div>}
        {country && <div className={textBlack}>{country}</div>}
      </div>
    </div>
  );
};
